module.exports = __webpack_public_path__ + "static/media/componentsDo.ba289968.svg";